module.exports = __webpack_public_path__ + "static/img/skill-pubgm.3cbfc345.png";